import { render, staticRenderFns } from "./BundleComponentsBadge.vue?vue&type=template&id=b2780452"
import script from "./BundleComponentsBadge.vue?vue&type=script&lang=js"
export * from "./BundleComponentsBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports